(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery"], factory);
	else if(typeof exports === 'object')
		exports["Timum"] = factory(require("jquery"));
	else
		root["Timum"] = factory(root["jQuery"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__3755__) {
return 